import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import { CopyToClipboardButton } from '@/components/buttons/copyToClipboardButton';
import { MainDialog } from '@/components/dialogs/mainDialog';
import { JsonViewerPanel } from '@/components/shared/jsonViewer';
export const JsonDialog = t0 => {
  const $ = _c(21);
  const {
    isOpen,
    onClose,
    title,
    data,
    closeTestId
  } = t0;
  let t1;
  if ($[0] !== onClose || $[1] !== title) {
    t1 = {
      title,
      onClose
    };
    $[0] = onClose;
    $[1] = title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== closeTestId || $[4] !== onClose) {
    t2 = {
      text: "Close",
      onClick: onClose,
      "data-testid": closeTestId
    };
    $[3] = closeTestId;
    $[4] = onClose;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== data) {
    t3 = JSON.stringify(data);
    $[6] = data;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <CopyToClipboardButton textToCopy={t3} buttonLabel="Copy" />;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t4) {
    t5 = {
      primaryButton: t2,
      children: t4
    };
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      minHeight: "350px",
      maxHeight: "80%",
      overflow: "auto"
    };
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== data) {
    t7 = <Box className="px-[40px]" sx={t6}><JsonViewerPanel data={data} /></Box>;
    $[14] = data;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== isOpen || $[17] !== t1 || $[18] !== t5 || $[19] !== t7) {
    t8 = <MainDialog isOpen={isOpen} isLoading={false} header={t1} footer={t5}>{t7}</MainDialog>;
    $[16] = isOpen;
    $[17] = t1;
    $[18] = t5;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};